import React, { useRef, useState, useEffect } from "react"
import bell from "../assets/Alarm.png"
import logomain from "../assets/logo-undeline.png"
import logotrans from "../assets/logo-trans.png"
import { GoChevronDown } from "react-icons/go"
import { BsBell, BsMoon } from "react-icons/bs"
import { HiOutlineUserCircle } from "react-icons/hi"
import { RiHome5Line } from "react-icons/ri"
import { useHistory } from "react-router-dom"
import { IoIosLogOut } from "react-icons/io"
import useAuth from "../context/userContext"
import { PLATFORM_LINKS } from "../components/constants"
import { FaUserCircle } from "react-icons/fa"
import { FiMenu } from "react-icons/fi"
import NotificationDrawer from "../components/Drawers/NotificationDrawer"
import useSWR from "swr"
import { fetcher } from "../utils/api"

const dropdownItems = [
  {
    label: "My Account",
    icon: <HiOutlineUserCircle size={20} className="text-black font-light dark:text-white" />,
    href: "/admin/settings"
  },
  {
    label: "Homepage",
    icon: <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black font-light dark:text-white">
      <path d="M9.02 3.47297L3.63 7.67298C2.73 8.37298 2 9.86297 2 10.993V18.403C2 20.723 3.89 22.623 6.21 22.623H17.79C20.11 22.623 22 20.723 22 18.413V11.133C22 9.92297 21.19 8.37298 20.2 7.68298L14.02 3.35298C12.62 2.37298 10.37 2.42298 9.02 3.47297Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 18.623V15.623" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    href: PLATFORM_LINKS.landingpage,
    external: true
  },
  {
    label: "Marketplace",
    icon: <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black font-light dark:text-white">
      <path d="M18.125 8.88281V14.3828C18.125 17.1442 15.8864 19.3828 13.125 19.3828H6.875C4.11358 19.3828 1.875 17.1442 1.875 14.3828V8.88281" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      <path d="M7.5 16.8828C7.5 15.5021 8.61929 14.3828 10 14.3828V14.3828C11.3807 14.3828 12.5 15.5021 12.5 16.8828V19.3828H7.5V16.8828Z" stroke="currentColor" stroke-width="1.5" />
      <path d="M1.24673 3.09895C1.39103 1.83629 2.45968 0.882812 3.73056 0.882812H8.12512L7.26843 6.87965C7.04275 8.4594 5.6898 9.63281 4.094 9.63281V9.63281C2.17878 9.63281 0.69062 7.96489 0.908087 6.06205L1.24673 3.09895Z" stroke="currentColor" stroke-width="1.5" />
      <path d="M8.125 0.882812H11.875L12.6831 6.53922C12.9163 8.17199 11.6494 9.63281 10 9.63281V9.63281C8.35065 9.63281 7.08369 8.17199 7.31694 6.53922L8.125 0.882812Z" stroke="currentColor" stroke-width="1.5" />
      <path d="M11.875 0.882812H16.2694C17.5403 0.882812 18.609 1.83629 18.7533 3.09895L19.0919 6.06212C19.3094 7.96492 17.8213 9.63281 15.9061 9.63281V9.63281C14.3103 9.63281 12.9574 8.45942 12.7317 6.8797L11.875 0.882812Z" stroke="currentColor" stroke-width="1.5" />
    </svg>,
    href: PLATFORM_LINKS.marketplace,
    external: true
  },
  {
    label: "Orders",
    icon: <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black font-light dark:text-white">
      <path d="M22 6.63281V9.05281C22 10.6328 21 11.6328 19.42 11.6328H16V4.64281C16 3.53281 16.91 2.63281 18.02 2.63281C19.11 2.64281 20.11 3.08281 20.83 3.80281C21.55 4.53281 22 5.53281 22 6.63281Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2 7.63281V21.6328C2 22.4628 2.94 22.9328 3.6 22.4328L5.31 21.1528C5.71 20.8528 6.27 20.8928 6.63 21.2528L8.29 22.9228C8.68 23.3128 9.32 23.3128 9.71 22.9228L11.39 21.2428C11.74 20.8928 12.3 20.8528 12.69 21.1528L14.4 22.4328C15.06 22.9228 16 22.4528 16 21.6328V4.63281C16 3.53281 16.9 2.63281 18 2.63281H7H6C3 2.63281 2 4.42281 2 6.63281V7.63281Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 13.6426H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 9.64258H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.99609 13.6328H6.00508" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.99609 9.63281H6.00508" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    href: "/admin/service-orders",
  },
  {
    label: "Settings",
    icon: <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black font-light dark:text-white">
      <path d="M12 15.1328C13.6569 15.1328 15 13.7897 15 12.1328C15 10.476 13.6569 9.13281 12 9.13281C10.3431 9.13281 9 10.476 9 12.1328C9 13.7897 10.3431 15.1328 12 15.1328Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2 13.0132V11.2532C2 10.2132 2.85 9.35324 3.9 9.35324C5.71 9.35324 6.45 8.07324 5.54 6.50324C5.02 5.60324 5.33 4.43324 6.24 3.91324L7.97 2.92324C8.76 2.45324 9.78 2.73324 10.25 3.52324L10.36 3.71324C11.26 5.28324 12.74 5.28324 13.65 3.71324L13.76 3.52324C14.23 2.73324 15.25 2.45324 16.04 2.92324L17.77 3.91324C18.68 4.43324 18.99 5.60324 18.47 6.50324C17.56 8.07324 18.3 9.35324 20.11 9.35324C21.15 9.35324 22.01 10.2032 22.01 11.2532V13.0132C22.01 14.0532 21.16 14.9132 20.11 14.9132C18.3 14.9132 17.56 16.1932 18.47 17.7632C18.99 18.6732 18.68 19.8332 17.77 20.3532L16.04 21.3432C15.25 21.8132 14.23 21.5332 13.76 20.7432L13.65 20.5532C12.75 18.9832 11.27 18.9832 10.36 20.5532L10.25 20.7432C9.78 21.5332 8.76 21.8132 7.97 21.3432L6.24 20.3532C5.33 19.8332 5.02 18.6632 5.54 17.7632C6.45 16.1932 5.71 14.9132 3.9 14.9132C2.85 14.9132 2 14.0532 2 13.0132Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    href: "/admin/settings",
  },
  {
    label: "Support",
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black font-light dark:text-white">
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    href: "/support",
    external: false
  },
]

const Navbar = () => {
  const [open, setOpen] = useState(false)
  const [openNotificationModal, setOpenNotificationsModal] = useState(false)
  const [isImpersonation, setIsImpersonation] = useState(false)
  const { logout } = useAuth()
  const router = useHistory()
  const accountRef = useRef(null)
  const dropdownRef = useRef(null)

  const [darkMode, setDarkMode] = useState(() => {
    const stored = localStorage.getItem('theme')
    if (stored) return stored === 'dark'
    localStorage.setItem('theme', 'dark')
    return true
  })

  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false)

  const { data: notifications, isLoading, mutate } = useSWR(
    `notifications/`,
    fetcher
  )

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark')
      localStorage.setItem('theme', 'dark')
    } else {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('theme', 'light')
    }
  }, [darkMode])

  // Check for impersonation status
  useEffect(() => {
    const checkImpersonation = () => {
      const isImpersonating = window.localStorage.getItem("is_impersonation") === "true"
      setIsImpersonation(isImpersonating)
    }

    checkImpersonation()
    // Check periodically in case it changes
    const interval = setInterval(checkImpersonation, 1000)
    return () => clearInterval(interval)
  }, [])

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        accountRef.current &&
        !accountRef.current.contains(event.target)
      ) {
        setOpen(false)
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [open])

  return (
    <>
      <div
        className="dark:bg-dark bg-white border-b border-gray-100 dark:border-border-dark w-full flex flex-row justify-between items-center py-4 px-5 md:px-10 lg:px-10 fixed left-0 right-0 transition-all duration-300"
        style={{
          top: isImpersonation ? '56px' : '0',
          zIndex: 999,
          position: 'fixed'
        }}
      >
        <div className="flex flex-col items-start justify-center">
          <img
            src={darkMode ? logotrans : logomain}
            alt="underline"
            className="w-32 ml-1 object-contain transition-all"
          />
        </div>
        {/* Desktop actions */}
        <div className="hidden md:flex items-center gap-6">
          <div
            className="flex items-center gap-1 cursor-pointer relative"
            ref={accountRef}
            onClick={() => setOpen((prev) => !prev)}
          >
            <HiOutlineUserCircle size={24} className="text-black font-light dark:text-white" />
            <span className="font-light text-base text-black dark:text-white mr-3">Account</span>
            <GoChevronDown size={18} className="text-black font-light dark:text-white" />
            {/* Dropdown menu */}
            <div
              ref={dropdownRef}
              className={`absolute right-0 top-10 min-w-[210px] bg-white dark:bg-dark rounded-lg shadow-lg border border-gray-100 dark:border-border-dark py-2 z-50 transition-all duration-200 ease-in-out
              ${open ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-2 pointer-events-none'}
            `}
              style={{ boxShadow: '0 10px 24px rgba(0,0,0,0.08)' }}
            >
              {dropdownItems?.map((menu) => <button key={menu?.label}
                className="flex flex-row items-center justify-between px-4 py-3 hover:bg-gray-100 dark:hover:bg-secondaryDark transition-colors w-full outline-none border-none"
                onClick={() => {
                  if (menu?.external) {
                    window.open(menu?.href, '_blank')
                  } else {
                    router.push(menu?.href)
                  }
                }}
              >
                <div className="flex flex-row items-center gap-2">
                  {menu?.icon}
                  <span className="font-light text-sm text-black dark:text-white">{menu?.label}</span>
                </div>
                {menu?.external && <svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black font-light dark:text-white">
                  <path d="M8.6663 8.46598C8.53964 8.46598 8.41297 8.41931 8.31297 8.31931C8.11964 8.12598 8.11964 7.80598 8.31297 7.61264L13.7796 2.14598C13.973 1.95264 14.293 1.95264 14.4863 2.14598C14.6796 2.33931 14.6796 2.65931 14.4863 2.85264L9.01964 8.31931C8.91964 8.41931 8.79297 8.46598 8.6663 8.46598Z" fill="currentColor" />
                  <path d="M14.6648 5.66582C14.3915 5.66582 14.1648 5.43915 14.1648 5.16582V2.46582H11.4648C11.1915 2.46582 10.9648 2.23915 10.9648 1.96582C10.9648 1.69249 11.1915 1.46582 11.4648 1.46582H14.6648C14.9382 1.46582 15.1648 1.69249 15.1648 1.96582V5.16582C15.1648 5.43915 14.9382 5.66582 14.6648 5.66582Z" fill="currentColor" />
                  <path d="M9.9987 15.8001H5.9987C2.3787 15.8001 0.832031 14.2535 0.832031 10.6335V6.63346C0.832031 3.01346 2.3787 1.4668 5.9987 1.4668H7.33203C7.60536 1.4668 7.83203 1.69346 7.83203 1.9668C7.83203 2.24013 7.60536 2.4668 7.33203 2.4668H5.9987C2.92536 2.4668 1.83203 3.56013 1.83203 6.63346V10.6335C1.83203 13.7068 2.92536 14.8001 5.9987 14.8001H9.9987C13.072 14.8001 14.1654 13.7068 14.1654 10.6335V9.30013C14.1654 9.0268 14.392 8.80013 14.6654 8.80013C14.9387 8.80013 15.1654 9.0268 15.1654 9.30013V10.6335C15.1654 14.2535 13.6187 15.8001 9.9987 15.8001Z" fill="currentColor" />
                </svg>
                }
              </button>
              )}
              <div className="border-t dark:border-border-dark my-1" />
              <button
                onClick={() => logout()}
                className="flex flex-row items-center gap-2 w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 dark:hover:bg-secondaryDark transition-colors">
                <IoIosLogOut size={20} className="text-red-600 font-light" />
                Logout
              </button>
            </div>
          </div>
          <button className="relative" onClick={() => { setOpenNotificationsModal(true); setMobileDropdownOpen(false) }}>
            <BsBell size={17} className="text-black dark:text-white" />
            {notifications?.length > 0 && <span className="absolute -top-2 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">{notifications?.length}</span>}
          </button>
          <button onClick={() => setDarkMode((prev) => !prev)}>
            <BsMoon size={17} className="text-black dark:text-white" />
          </button>
        </div>
        {/* Mobile actions */}
        <div className="flex md:hidden items-center gap-2">
          <button
            className="relative"
            onClick={() => setMobileDropdownOpen((prev) => !prev)}
          >
            <FaUserCircle size={26} className="text-black dark:text-white" />
          </button>
          {/* Mobile dropdown */}
          {mobileDropdownOpen && (
            <div className="absolute right-2 top-14 min-w-[200px] bg-white dark:bg-dark rounded-lg shadow-lg border border-gray-100 dark:border-border-dark py-2 z-50 transition-all duration-200 ease-in-out">
              {dropdownItems?.map((menu) => (
                <button
                  key={menu?.label}
                  className="flex flex-row items-center justify-between px-4 py-3 hover:bg-gray-100 dark:hover:bg-secondaryDark transition-colors w-full outline-none border-none"
                  onClick={() => {
                    setMobileDropdownOpen(false)
                    if (menu?.external) {
                      window.open(menu?.href, '_blank')
                    } else {
                      router.push(menu?.href)
                    }
                  }}
                >
                  <div className="flex flex-row items-center gap-2">
                    {menu?.icon}
                    <span className="font-light text-sm text-black dark:text-white">{menu?.label}</span>
                  </div>
                  {menu?.external && <svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black font-light dark:text-white">
                    <path d="M8.6663 8.46598C8.53964 8.46598 8.41297 8.41931 8.31297 8.31931C8.11964 8.12598 8.11964 7.80598 8.31297 7.61264L13.7796 2.14598C13.973 1.95264 14.293 1.95264 14.4863 2.14598C14.6796 2.33931 14.6796 2.65931 14.4863 2.85264L9.01964 8.31931C8.91964 8.41931 8.79297 8.46598 8.6663 8.46598Z" fill="currentColor" />
                    <path d="M14.6648 5.66582C14.3915 5.66582 14.1648 5.43915 14.1648 5.16582V2.46582H11.4648C11.1915 2.46582 10.9648 2.23915 10.9648 1.96582C10.9648 1.69249 11.1915 1.46582 11.4648 1.46582H14.6648C14.9382 1.46582 15.1648 1.69249 15.1648 1.96582V5.16582C15.1648 5.43915 14.9382 5.66582 14.6648 5.66582Z" fill="currentColor" />
                    <path d="M9.9987 15.8001H5.9987C2.3787 15.8001 0.832031 14.2535 0.832031 10.6335V6.63346C0.832031 3.01346 2.3787 1.4668 5.9987 1.4668H7.33203C7.60536 1.4668 7.83203 1.69346 7.83203 1.9668C7.83203 2.24013 7.60536 2.4668 7.33203 2.4668H5.9987C2.92536 2.4668 1.83203 3.56013 1.83203 6.63346V10.6335C1.83203 13.7068 2.92536 14.8001 5.9987 14.8001H9.9987C13.072 14.8001 14.1654 13.7068 14.1654 10.6335V9.30013C14.1654 9.0268 14.392 8.80013 14.6654 8.80013C14.9387 8.80013 15.1654 9.0268 15.1654 9.30013V10.6335C15.1654 14.2535 13.6187 15.8001 9.9987 15.8001Z" fill="currentColor" />
                  </svg>}
                </button>
              ))}
              <button
                className="flex relative flex-row items-center gap-2 w-full text-left px-4 py-2 text-black dark:text-white hover:bg-gray-100 dark:hover:bg-secondaryDark transition-colors"
                onClick={() => { setMobileDropdownOpen(false) }}
              >
                <BsBell size={20} className="text-black dark:text-white" />
                <span className="font-light text-sm">Notifications</span>
                {notifications?.length > 0 && <span className="absolute -top-2 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">{notifications?.length}</span>}
              </button>
              <button
                className="flex flex-row items-center mt-2 gap-2 w-full text-left px-4 py-2 text-black dark:text-white hover:bg-gray-100 dark:hover:bg-secondaryDark transition-colors"
                onClick={() => { setDarkMode((prev) => !prev); setMobileDropdownOpen(false) }}
              >
                <BsMoon size={20} className="text-black dark:text-white" />
                <span className="font-light text-sm">{darkMode ? 'Light Mode' : 'Dark Mode'}</span>
              </button>
              <div className="border-t dark:border-border-dark my-1" />
              <button
                onClick={() => { logout(); setMobileDropdownOpen(false) }}
                className="flex flex-row items-center gap-2 w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 dark:hover:bg-secondaryDark transition-colors">
                <IoIosLogOut size={20} className="text-red-600 font-light" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      <NotificationDrawer
        open={openNotificationModal}
        setOpen={setOpenNotificationsModal}
        notifications={notifications}
        mutate={mutate}
      />
    </>

  )
}

export default Navbar
